import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ConditionalClassDirective } from '@core-mkt/services/conditional-class/conditional-class.directive';
import { EnvService } from '@core-mkt/services/env/env.service';
import { TopSectionTrustpilotComponent } from '@core-mkt/shared/components/top-section/top-section/trustpilot/top-section-trustpilot.component';
import { VisionButtonComponent } from '@core-mkt/shared/components/vision-button/vision-button/vision-button.component';
import { VisionButton } from '@core-mkt/shared/components/vision-button/vision-button/vision-button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { VisionModalService } from '../../../vision-modal/vision-modal.service';
import { TopSection } from '../top-section';

@Component({
  selector: 'top-section-course-popup-banner',
  templateUrl: './top-section-course-popup-banner.component.html',
  standalone: true,
  imports: [CommonModule, ConditionalClassDirective, TopSectionTrustpilotComponent, VisionButtonComponent, FontAwesomeModule],
})
export class TopSectionCoursePopupBannerComponent {
  @Input() ctaDisplay: boolean;
  @Input() showPriceCta: boolean;
  @Input() courseOverviewPopup: boolean;
  @Input() discountPrice: number;
  @Input() originalPrice: number;
  @Input() percentSavedText: string;
  @Input() data: TopSection;
  @Input() ctaButtonData: VisionButton;
  @Input() activateModalWrapper: (event: MouseEvent, wrapIdentifier?: string) => void;
  @Input() pricingText: string;
  @Input() moneyGuaranteeLabel: string;
  @Input() wistiaCtaData: VisionButton;
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;
  isCoursePopupMinimized = false;
  isMobileCoursePopupMinimized = true;
  private readonly brandId: string;

  constructor(private env: EnvService, private modal: VisionModalService) {
    this.brandId = this.env.get.xgritApiConfig.baseParams.brandId;
  }

  toggleCourseOverviewMinimize() {
    this.isCoursePopupMinimized = !this.isCoursePopupMinimized;
  }

  toggleMobileCourseOverviewMinimize() {
    this.isMobileCoursePopupMinimized = !this.isMobileCoursePopupMinimized;
  }

  activateModal(modalContent: string): void {
    this.modal.openModal({ showModal: true, modalContent: modalContent });
  }
}
